const AiReportsIcon = ({ size = 20, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M6.75 4.7915H13.25C14.5617 4.7915 15.625 5.85483 15.625 7.1665V15.3335C15.6248 16.645 14.5616 17.7085 13.25 17.7085H6.75C5.43843 17.7085 4.37518 16.645 4.375 15.3335V7.1665C4.375 5.85483 5.43833 4.7915 6.75 4.7915Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6663 4.16667V3.5C11.6663 2.94771 11.2186 2.5 10.6663 2.5H9.33301C8.78072 2.5 8.33301 2.94772 8.33301 3.5V4.16667"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5 5V6.08333C7.5 6.63562 7.94772 7.08333 8.5 7.08333H11.5C12.0523 7.08333 12.5 6.63562 12.5 6.08333V5"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.08301 9.58325H13.333"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.08301 12.0833H13.333"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.08301 14.5833H11.6663"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default AiReportsIcon
